import {
  fetchAffiliateAccount,
  fetchAffiliates,
  fetchMetaData,
  fetchPartners,
  fetchUserRole,
} from "../../../../../../apis/b2c_api";
import {
  setAffiliateAccount,
  setAffiliates,
  setPartners,
  setSelectedAffiliateId,
  setUserRole,
  setRoleLevel,
  logoutUser,
} from "../../../../../../store/user/user-reducer";

import { setMetadata } from "../../../../../../utils/metadata";
import {
  isMultiAffiliateEligibleRole,
  showErrorNotification,
} from "../../../../../../utils/common-utils";
import { getConfig } from "../../../../../../hooks/use-config";

export const recallMetadata = (cb: any) => {
  return fetchMetaData().then((metadata) => {
    setMetadata(metadata?.metadata ? metadata.metadata : {});
    cb();
  });
};

export const cachePartnersAndAffiliates = async (
  cb: any,
  dispatch: any,
  setMfaLoading?: (value: boolean) => void,
) => {
  try {
    const partnersResponse = await fetchPartners();
    const userRoleResponse = await fetchUserRole();

    const { userCurrentRole } = userRoleResponse;
    const affiliateProps = {
      pageNumber: 1,
      pageSize: 10000,
      status: "",
      sortBy: getConfig("affiliateSortQueryParam"),
    };

    if (userCurrentRole.roleLevel !== "AFFILIATE") {
      affiliateProps.status = "APPROVED, CLOSED";
    }
    const affiliatesResponse = await fetchAffiliates(affiliateProps);
    const { affiliates } = affiliatesResponse;
    if (affiliates.nodes.length === 1) {
      const { accountId, id: affiliateId } = affiliates.nodes[0];
      if (accountId && affiliateId) {
        const { affiliateAccountDetail } = await fetchAffiliateAccount({ accountId, affiliateId });
        if (affiliateAccountDetail) {
          dispatch(setAffiliateAccount(affiliateAccountDetail));
        }
      }
    }

    dispatch(setPartners(partnersResponse.partners));
    dispatch(setAffiliates(affiliates.nodes));
    dispatch(setUserRole(userCurrentRole.title));
    dispatch(setRoleLevel(userCurrentRole.roleLevel));

    if (
      affiliates.nodes?.length &&
      isMultiAffiliateEligibleRole(userCurrentRole.code || userCurrentRole.title)
    ) {
      const storedRaw = localStorage.getItem("selectedAffiliateId");
      let initialId: string | null = null;
      if (storedRaw) {
        try {
          const parsed = JSON.parse(storedRaw);
          if (typeof parsed === "string" && affiliates.nodes.some((n: any) => n.id === parsed)) {
            initialId = parsed;
          }
        } catch {
          initialId = null;
        }
      }
      if (!initialId) {
        initialId = affiliates.nodes[0].id;
      }
      dispatch(setSelectedAffiliateId(initialId));
    } else {
      dispatch(setSelectedAffiliateId(null));
    }

    cb();
  } catch (error) {
    if (setMfaLoading) {
      setMfaLoading(false);
    }

    showErrorNotification(error);

    setTimeout(() => {
      dispatch(logoutUser());
      window.location.assign("/login");
    }, 1000);
  }
};
